import React from "react";

import Menu from "./Menu.js";

import { useMenuUpdate } from "./Store";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Typography from "@mui/material/Typography";

export default function MenuComponent() {
  const toggleMenu = useMenuUpdate();
  return (
    <AppBar
      position="static"
      color="default"
      sx={{ bgcolor: "#113f67", color: "#e7eaf6" }}
    >
      <Toolbar>
        <IconButton
          className="menuButton"
          color="inherit"
          aria-label="Menu"
          onClick={toggleMenu}
        >
          <MenuIcon />
        </IconButton>
        <Typography className="flex" color="inherit">
          Fall-detection Application
        </Typography>
      </Toolbar>
      <Menu />
    </AppBar>
  );
}
